module.exports = __webpack_public_path__ + "static/img/word.5873ff38.png";